import { useState } from 'react';
import './assets/css/custom.css';
import $ from 'jquery';
import MainWrapper from './components/main-wrapper';
import './services/layoutService'
import { getHeader, getFooter } from './services/layoutService';
import Loader from './components/loader/loader';

function App() {
  const [isLoaded, setIsLoaded] = useState(true);
  function headerLanguage() {
    $(document).off('click').on('click', 'div.myparker-language', function (e) {
      debugger;
      setIsLoaded(false);
      e.preventDefault();
      e.stopPropagation();
      var language = $(this).find('input.form-check-input').val();
      var lang = language;
      switch (lang) {
        case 'JP':
          lang = 'JA';
          break;
        case 'DK':
          lang = 'da';
          break;
        case 'NO':
          lang = 'NB';
          break;
        default:
          break;
      }
      var script = getHeader('687PDC', lang);
      getFooter('687PDC', lang);
      script.onload = () => {
        setIsLoaded(true);
      }
      $("#language").val(lang);
    });
  }
  headerLanguage();
  return (
    <>
      <Loader show={isLoaded} />
      <div className="App">
        <MainWrapper />
      </div>
    </>
  );
}

export default App;
